// =============================================================
//  NETWORK CONFIG
//  Choose the active chain HERE. This is never surfaced in the UI.
//  'main'  -> BSC Mainnet (chainId 56)
//  'test'  -> BSC Testnet (chainId 97)
// =============================================================

export const ACTIVE_NETWORK = 'main'; // <-- switch to 'main' for production

export const NETWORKS = {
  main: {
    key: 'main',
    chainId: 56,
    chainIdHex: '0x38',
    chainName: 'BNB Smart Chain',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: ['https://bsc-dataseed.binance.org/'],
    blockExplorerUrls: ['https://bscscan.com'],
  },
  test: {
    key: 'test',
    chainId: 97,
    chainIdHex: '0x61',
    chainName: 'BNB Smart Chain',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
    blockExplorerUrls: ['https://bscscan.com'],
  },
};

export const CURRENT = NETWORKS[ACTIVE_NETWORK];
